import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { NewsletterRegisterComponent } from './newsletter-register/newsletter-register.component';
import { NewsletterResponse } from 'app/shared/models/ei-models';
import { TopicoResponse } from 'app/shared/models/ei-models/newsletter/response/topico.response';
import { NewsletterService } from 'app/shared/services/edduca-imob/newsletter/newsletter.service';
import { NewsletterModalComponent } from './newsletter-modal/newsletter-modal.component';
import { GlobalService, AuthService } from 'app/shared/services/core';
import { PerfilEnum } from 'app/shared/models/core/security/perfil.enum';
import { useMenuTracking } from 'app/shared/hooks';

@Component({
  selector: 'app-newsletter',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatIconModule],
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss']
})
export class NewsletterComponent implements OnInit {
  filtro = '';
  isAdmSistema = false;
  topics: TopicoResponse[] = [];
  private topicMap: Record<number, string> = {};

  newsletters: NewsletterResponse[] = [];
  selectedTopicId: number | null = null;
  
  private menuTracking = useMenuTracking();

  constructor(
    private dialog: MatDialog,
    private newsletterService: NewsletterService,
    private _globalService: GlobalService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Registrar acesso ao menu newsletter para gamificação
    this.menuTracking.registrarAcessoMenu('newsletter');
    
    // Apenas ADM_SISTEMA pode cadastrar newsletters
    const currentUser = this.authService.getUserInToken();
    this.isAdmSistema = currentUser?.perfilId === PerfilEnum.ADM_SISTEMA;
    
    this.loadTopics();
    this.loadNewsletters();
  }

  abrirForm(): void {
    this.dialog.open(NewsletterRegisterComponent, {
      panelClass: ['modal-dark', 'modal-big'],
      width: '65vw',
      height: '88vh',
      maxHeight: '88vh',
      maxWidth: '65vw',
      autoFocus: false
    })
    .afterClosed()
    .subscribe(res => { if (res === true) this.loadNewsletters(); });
  }  
  
  private loadTopics(): void {
    this.newsletterService.listarTopicos()
      .subscribe(tops => {
        this.topics = tops.map(t => new TopicoResponse(t));
        this.topicMap = this.topics.reduce((m, t) => {
          if (t.id != null) m[t.id] = t.nome ?? '';
          return m;
        }, {} as Record<number, string>);
      });
  }

  private loadNewsletters(): void {
    this.newsletterService.listar()
      .subscribe(news => this.newsletters = news);
  }

  selectTopic(topic: TopicoResponse): void {
    this.selectedTopicId = this.selectedTopicId === topic.id ? null : topic.id;
  }

  getTopicName(id?: number): string {
    return id != null ? (this.topicMap[id] ?? '') : '';
  }

  filteredNews(): NewsletterResponse[] {
    const search = (this.filtro ?? '').toString().trim().toLowerCase();
  
    const list = this.newsletters ?? [];
    if (!list.length) return [];
  
    const hasTopicFilter = this.selectedTopicId !== null && this.selectedTopicId !== undefined;
  
    return list.filter((item) => {
      const matchTopic = !hasTopicFilter
        ? true
        : item.topicoId === this.selectedTopicId;
  
      const tituloLower = (item?.titulo ?? '').toLowerCase();
      const textoLower  = (item?.texto  ?? '').toLowerCase();
      const matchText =
        search === '' ||
        tituloLower.includes(search) ||
        textoLower.includes(search);
  
      return matchTopic && matchText;
    });
  }

  abrirModal(id: number): void {
      this.dialog.open(NewsletterModalComponent, {
        panelClass: ['modal-dark', 'newsletter-modal-panel'],
        width: '90vw',
        maxWidth: '1000px',
        height: '90vh',
        maxHeight: '90vh',
        autoFocus: false,
        data: id
      })
  }
}
